export const apiConfig = {
    baseUrl: import.meta.env.VITE_END_POINT_URL,
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      headers.set("Accept", "application/json");
      return headers;
    },
    credentials: "include",
  };
  